import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "partner-area pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "partner-bg mb-4 d-flex align-items-center justify-content-center p-3" }
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "section-title text-center mb-5",
        "data-aos": "fade-up",
        "data-aos-duration": "1000"
      }, [
        _createElementVNode("h5", { class: "text-secondary fw-bold" }, "الخدمة متوافقة وتعمل على جميع الأنظمة والأجهزة")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportedBrands, (brand, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: brand.id,
            class: "col-6 col-sm-4 col-md-3 col-xxl-2 text-center",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": (index + 1) * 100
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: brand.image,
                alt: brand.name,
                class: "img-fluid",
                style: {"max-height":"50px","filter":"grayscale(100%)","transition":"filter 0.3s"},
                onMouseover: _cache[0] || (_cache[0] = ($event: any) => ($event.currentTarget.style.filter = 'grayscale(0%)')),
                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($event.currentTarget.style.filter = 'grayscale(100%)'))
              }, null, 40, _hoisted_6)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}